'use client';

import Image from 'next/image';

export default function About() {
  return (
    <main style={{ backgroundColor: '#ffffff' }}>
      {/* ===== HERO HEADER ===== */}
      <div
        style={{
          position: 'relative',
          background: 'linear-gradient(135deg, #e85d28 0%, #d14c2b 50%, #c1402c 100%)',
          overflow: 'hidden',
        }}
      >
        <div
          className="container text-center"
          style={{ paddingTop: '3.75rem', paddingBottom: '4.75rem' }}
        >
          <h1
            className="fw-bold text-white mb-2"
            style={{
              fontSize: 'clamp(2.75rem, 5.5vw, 4.25rem)',
              fontWeight: 800,
              letterSpacing: '-0.025em',
              lineHeight: 1.15,
            }}
          >
            About
          </h1>
          <p
            className="text-white mb-0"
            style={{
              fontSize: 'clamp(1.05rem, 1.8vw, 1.28rem)',
              fontWeight: 500,
              opacity: 0.95,
            }}
          >
            About Avetium Payroll
          </p>
        </div>
      </div>

      {/* ===== ABOUT MAIN CONTENT ===== */}
      <section style={{ backgroundColor: '#ffffff', padding: '5rem 1.5rem 7.5rem' }}>
        {/* Eyebrow and Headline Header */}
        <div className="container text-center" style={{ maxWidth: '880px', marginBottom: '4rem' }}>
          <p
            style={{
              fontSize: '0.78rem',
              fontWeight: 800,
              letterSpacing: '0.12em',
              color: '#111827',
              textTransform: 'uppercase',
              marginBottom: '1.25rem',
            }}
          >
            BACKED BY AVETIUM TECHNOLOGIES
          </p>

          <h2
            style={{
              fontSize: 'clamp(1.85rem, 3.4vw, 2.75rem)',
              fontWeight: 800,
              lineHeight: 1.25,
              letterSpacing: '-0.025em',
              margin: 0,
            }}
          >
            <span style={{ color: '#ea580c' }}>
              Enterprise–grade payroll, built by people who understand{' '}
            </span>
            <span style={{ color: '#111827' }}>African businesses.</span>
          </h2>
        </div>

        {/* 2-Column Content Row */}
        <div className="container" style={{ maxWidth: '1180px' }}>
          <div className="row align-items-center g-5">
            {/* Left Column: Image with rounded corners & shadow */}
            <div className="col-12 col-md-5">
              <div
                style={{
                  position: 'relative',
                  width: '100%',
                  height: '380px',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  backgroundColor: '#f3f4f6',
                  boxShadow:
                    '0 20px 45px -15px rgba(0, 0, 0, 0.22), 0 0 0 1px rgba(0, 0, 0, 0.04)',
                }}
              >
                <Image
                  src="/images/image 53.png"
                  alt="Avetium Payroll team"
                  fill
                  priority
                  style={{ objectFit: 'cover' }}
                />
              </div>
            </div>

            {/* Right Column: Narrative Copy */}
            <div className="col-12 col-md-7">
              <p
                style={{
                  color: '#111827',
                  fontSize: 'clamp(1.1rem, 1.6vw, 1.28rem)',
                  lineHeight: 1.68,
                  fontWeight: 400,
                  margin: 0,
                }}
              >
                Avetium Payroll is a product of Avetium Technologies — a business technology
                company operating under Avetium Holdings. Being African means Avetium Payroll
                isn&apos;t a side project. It&apos;s built on the same engineering discipline,
                security standards, and long-term support that Avetium brings to enterprise
                clients across aviation, fintech, healthcare, retail and the public sector.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}